// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";

// Dto
import { SupportingInformationDTO } from "Globals/Models/DTO/SupportingInformationDTO";
import { IsNotEmpty } from "class-validator";

export class SupportingInformationModel extends ModelBase<SupportingInformationModel, SupportingInformationDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";

    @IsNotEmpty({ message: "Document Type must be selected " })
    @MobX.observable
    public documentTypeId: string | null = null;

    @MobX.observable public documentUrl: string = "";
    @MobX.observable public fileName: string = "";
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: SupportingInformationDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.documentTypeId = model.documentTypeId;
            this.documentUrl = model.documentUrl;
            this.fileName = model.fileName;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): SupportingInformationDTO => {
        let model: SupportingInformationDTO = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            documentTypeId: this.documentTypeId,
            documentUrl: this.documentUrl,
            fileName: this.fileName,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };

    @MobX.action
    public resetModel = (): void => {
        this.id = "";
        this.applicantId = "";
        this.documentTypeId = "";
        this.documentUrl = "";
        this.fileName = "";
        this.createdDate = null;
        this.isDeleted = false;
    };
}
